export default __webpack_public_path__ + "static/media/banner3.8cd5ec57.png";